var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("How Asoko helps data-driven Investors")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Asoko provides Investors with Africa’s most reliable private market data to support their market sizing, origination and due diligence.Our Pan-African data-set covers business profiles, shareholders, historical deals and future funding requirements."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Asoko’s data solutions help to speed-up an Investor’s research process so they can focus less on research and more on deal-making."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openSolutions },
          },
          [_vm._v("Learn More")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }